import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AppNotification } from '@app/helpers';
import { BrokerAdminService, BrokerGroupService, FileUploaderService, SurveyService } from '@app/services';

@Component({
  selector: 'app-broker-admin-add',
  templateUrl: './broker-admin-add.component.html',
  styleUrls: ['./broker-admin-add.component.scss']
})
export class BrokerAdminAddComponent implements OnInit {
  @Output() onDone: any = new EventEmitter();
  @Input() user: any;
  admin: any;
  surveyList: any[]
  brokerGroupList: any[]

  logoSelected: File;
  logoSrc: any;

  constructor(
    private brokerAdminService: BrokerAdminService,
    private surveyService: SurveyService,
    private brokerGroupService: BrokerGroupService,
    private fileUploaderService: FileUploaderService) { }

  ngOnInit(): void {
    this.admin = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      business: "",
      brokerGroup: null,
      surveys: [],
      licenses: {}
    }
    console.log(this.user)
    if (this.user != null) {
      this.admin = {
        firstName: this.user.user.firstName,
        lastName: this.user.user.lastName,
        email: this.user.user.email,
        phone: this.user.user.phone,
        business: this.user.business,
        brokerGroup: this.user.brokerGroup,
        surveys: this.user.surveys,
        licenses: this.user.licenses || {},
        isActive: this.user.user.isActive
      }

      if(this.user.logo != null) {
        this.logoSrc = this.user.logo
      }
    }
    this.getBrokerGroupList();
    this.getSurveyList();
  }

  async onSaveHandler() {
    if(this.logoSelected) {
      let uploaded: any = await this.fileUploaderService.uploadUsingPreSignedUrl({
        fileName: this.logoSelected.name,
        contentType: this.logoSelected.type,
        file: this.logoSelected
      })
      this.admin.logo = uploaded.url;
    }
    if (this.user != null) {
      let updateObj: any = {
        brokerGroup: this.admin.brokerGroup,
        surveys: this.admin.surveys,
        licenses: this.admin.licenses,
        firstName: this.admin.firstName,
        lastName: this.admin.lastName,
        email: this.admin.email,
        phone: this.admin.phone,
        business: this.admin.business,
        isActive: this.admin.isActive
      };

      if(this.admin?.logo?.url || this.logoSrc) {
        updateObj.logo = this.admin?.logo?.url || this.logoSrc
      }

      return this.brokerAdminService.update(this.user._id, updateObj).subscribe({
        next: (res: any) => {
          this.onDone.emit(res.data)
        },
        error: (error: any) => {
          if(typeof error.data.data == "string") {
            AppNotification.error(error.data.data)
          } else {
            AppNotification.error("Something went wrong!")
          }
        }
      })
    }
    return this.brokerAdminService.add(this.admin).subscribe({
      next: (res: any) => {
        this.onDone.emit(res.data)
      },
      error: (error: any) => {
        if(typeof error.data == "string") {
          AppNotification.error(error.data)
        } else {
          AppNotification.error("Something went wrong!")
        }
      }
    })
  }

  getSurveyList() {
    this.surveyService.list().subscribe({
      next: (res: any) => {
        this.surveyList = res.data
      }
    })
  }

  getBrokerGroupList() {
    this.brokerGroupService.list().subscribe({
      next: (res: any) => {
        this.brokerGroupList = res.data
      }
    })
  }

  onBrokerChanged() {
    if(this.admin.brokerGroup == null) return;
    for(let brokerGroup of this.brokerGroupList) {
      if( brokerGroup._id == this.admin.brokerGroup ) {
        this.admin.surveys = brokerGroup.surveys
      }
    }
  }



  onLogoSelect(e: any) {
    console.log(e.target.files[0])
    this.logoSelected = e.target.files?.[0];
    if (this.logoSelected) {
      const file = this.logoSelected;

      const reader = new FileReader();
      reader.onload = e => this.logoSrc = reader.result;

      reader.readAsDataURL(file);
    }
  }

}
